import { useState } from 'react'
import axios, { AxiosResponse } from 'axios'

export type Response = { result?: AxiosResponse<any>; error?: any }

export function useUpload() {
    const [loading, setLoading] = useState(false)

    const upload = async (formData: any): Promise<Response> => {
        setLoading(true)
        try {
            const url = `${process.env.REACT_APP_API}/api/upload/to-temp`
            const result = await axios.post(url, formData)
            setLoading(false)
            return { result }
        } catch (error) {
            setLoading(false)
            return { error }
        }
    }

    return { upload, loading }
}
